var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestopsStep9({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 562,
    height: 270,
    viewBox: "0 0 562 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_933_49183",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 562,
    height: 270
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 562,
    height: 270,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_933_49183)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.8472,
    y: 1,
    width: 510.153,
    height: 290.24,
    rx: 15,
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.9883,
    y: 216.003,
    width: 199.388,
    height: 5.75977,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.517,
    y: 216.003,
    width: 67.44,
    height: 5.86435,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.917,
    y: 216.003,
    width: 43.0052,
    height: 5.86435,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.517,
    y: 228.709,
    width: 51.8017,
    height: 5.86435,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.917,
    y: 228.709,
    width: 70.3722,
    height: 5.86435,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.517,
    y: 241.416,
    width: 35.1861,
    height: 5.86435,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.917,
    y: 241.416,
    width: 53.7565,
    height: 5.86435,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.9883,
    y: 228.709,
    width: 139.047,
    height: 5.75977,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.9883,
    y: 241.416,
    width: 98.7165,
    height: 5.86435,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.5557,
    y: 30.7991,
    width: 444.69,
    height: 157.337,
    stroke: "#D6DAE4",
    strokeDasharray: "5 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.867 123.364H326.633V153.633H295.867V123.364Z",
    fill: "#ECEEF5",
    stroke: "white",
    strokeWidth: 0.733945
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.367 122.63V92.1566L295.641 61.367H326.624V91.8492L295.341 122.63H264.367Z",
    fill: "#ECEEF5",
    stroke: "white",
    strokeWidth: 0.733945
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_933_49183)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 67.1658,
    width: 73.0937,
    height: 87.1714,
    transform: "rotate(-11.4955 7 67.1658)",
    fill: "#D7DBE5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.58962,
    y: 67.5561,
    width: 72.0937,
    height: 86.1714,
    transform: "rotate(-11.4955 7.58962 67.5561)",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_933_49183)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.7251,
    y: 51.8062,
    width: 73.0937,
    height: 90.7067,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.2251,
    y: 52.3062,
    width: 72.0937,
    height: 89.7067,
    stroke: "black",
    strokeDasharray: "4 1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_933_49183)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6833 46.558C48.0409 46.422 48.7465 46.5053 48.9327 46.9195C49.0914 47.2727 49.2278 47.868 49.2352 47.7412C49.2531 47.4591 49.2173 46.8492 49.3373 46.5305C49.4245 46.2982 49.5958 46.0796 49.8484 46.0024C50.0607 45.9367 50.3103 45.9137 50.5308 45.9603C50.764 46.0093 51.0091 46.1797 51.1008 46.3417C51.3705 46.8179 51.3749 47.7931 51.3876 47.7412C51.4353 47.5333 51.4398 46.8018 51.5985 46.5305C51.7035 46.3509 51.9687 46.1904 52.1103 46.1644C52.3293 46.1247 52.599 46.1124 52.8285 46.1583C53.014 46.1958 53.2651 46.4212 53.3329 46.5305C53.4961 46.7934 53.5877 47.5363 53.6153 47.7977C53.6272 47.9055 53.6704 47.4974 53.8336 47.2352C54.136 46.7468 55.2074 46.652 55.2476 47.7236C55.267 48.2234 55.2625 48.2005 55.2625 48.5368C55.2625 48.9312 55.2536 49.1696 55.2327 49.4555C55.2104 49.7604 55.1463 50.4521 55.0532 50.7869C54.9891 51.017 54.7768 51.5344 54.5667 51.8447C54.5667 51.8447 53.7665 52.8001 53.6793 53.2296C53.5922 53.6599 53.6212 53.663 53.6033 53.9671C53.5862 54.2721 53.6935 54.6726 53.6935 54.6726C53.6935 54.6726 53.0967 54.7521 52.7741 54.6986C52.4828 54.6512 52.1222 54.0566 52.0291 53.8747C51.9009 53.624 51.6275 53.6721 51.521 53.8571C51.3541 54.1498 50.9927 54.6749 50.7387 54.7078C50.2403 54.772 49.2077 54.7307 48.3993 54.723C48.3993 54.723 48.5371 53.9503 48.2302 53.6851C48.0029 53.4864 47.6118 53.0859 47.3779 52.875L46.758 52.171C46.5471 51.8959 46.0115 51.461 45.8319 50.6539C45.6732 49.9385 45.6889 49.5877 45.8595 49.3011C46.0323 49.0099 46.3587 48.8509 46.4957 48.8234C46.6507 48.7913 47.0113 48.7936 47.1476 48.8708C47.3138 48.9648 47.3808 48.9923 47.5112 49.1696C47.6826 49.4043 47.7437 49.5182 47.6699 49.2621C47.6133 49.0619 47.43 48.8074 47.3466 48.5208C47.2654 48.2448 47.0478 47.8 47.0635 47.3544C47.0694 47.1855 47.1402 46.7652 47.6833 46.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6833 46.558C48.0409 46.422 48.7465 46.5053 48.9327 46.9195C49.0914 47.2727 49.2278 47.868 49.2352 47.7412C49.2531 47.4591 49.2173 46.8492 49.3373 46.5305C49.4245 46.2982 49.5958 46.0796 49.8484 46.0024C50.0607 45.9367 50.3103 45.9137 50.5308 45.9603C50.764 46.0093 51.0091 46.1797 51.1008 46.3417C51.3705 46.8179 51.3749 47.7931 51.3876 47.7412C51.4353 47.5333 51.4398 46.8018 51.5985 46.5305C51.7035 46.3509 51.9687 46.1904 52.1103 46.1644C52.3293 46.1247 52.599 46.1124 52.8285 46.1583C53.014 46.1958 53.2651 46.4212 53.3329 46.5305C53.4961 46.7934 53.5877 47.5363 53.6153 47.7977C53.6272 47.9055 53.6704 47.4974 53.8336 47.2352C54.136 46.7468 55.2074 46.652 55.2476 47.7236C55.267 48.2234 55.2625 48.2005 55.2625 48.5368C55.2625 48.9312 55.2536 49.1696 55.2327 49.4555C55.2104 49.7604 55.1463 50.4521 55.0532 50.7869C54.9891 51.017 54.7768 51.5344 54.5667 51.8447C54.5667 51.8447 53.7665 52.8001 53.6793 53.2296C53.5922 53.6599 53.6212 53.663 53.6033 53.9671C53.5862 54.2721 53.6935 54.6726 53.6935 54.6726C53.6935 54.6726 53.0967 54.7521 52.7741 54.6986C52.4828 54.6512 52.1222 54.0566 52.0291 53.8747C51.9009 53.624 51.6275 53.6721 51.521 53.8571C51.3541 54.1498 50.9927 54.6749 50.7387 54.7078C50.2403 54.772 49.2077 54.7307 48.3993 54.723C48.3993 54.723 48.5371 53.9503 48.2302 53.6851C48.0029 53.4864 47.6118 53.0859 47.3779 52.875L46.758 52.171C46.5471 51.8959 46.0115 51.461 45.8319 50.6539C45.6732 49.9385 45.6889 49.5877 45.8595 49.3011C46.0323 49.0099 46.3587 48.8509 46.4957 48.8234C46.6507 48.7913 47.0113 48.7936 47.1476 48.8708C47.3138 48.9648 47.3808 48.9923 47.5112 49.1696C47.6826 49.4043 47.7437 49.5182 47.6699 49.2621C47.6133 49.0619 47.43 48.8074 47.3466 48.5208C47.2654 48.2448 47.0478 47.8 47.0635 47.3544C47.0694 47.1855 47.1402 46.7652 47.6833 46.558Z",
    stroke: "#101828",
    strokeWidth: 0.550459,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3668 50C49.3668 49.7974 49.2025 49.6331 48.9998 49.6331C48.7971 49.6331 48.6328 49.7974 48.6328 50V52.2019C48.6328 52.4045 48.7971 52.5688 48.9998 52.5688C49.2025 52.5688 49.3668 52.4045 49.3668 52.2019V50ZM50.4676 49.6331C50.6702 49.6331 50.8345 49.7974 50.8345 50V52.2019C50.8345 52.4045 50.6702 52.5688 50.4676 52.5688C50.2649 52.5688 50.1006 52.4045 50.1006 52.2019V50C50.1006 49.7974 50.2649 49.6331 50.4676 49.6331ZM51.9353 49.6331C52.138 49.6331 52.3023 49.7974 52.3023 50V52.2019C52.3023 52.4045 52.138 52.5688 51.9353 52.5688C51.7327 52.5688 51.5684 52.4045 51.5684 52.2019V50C51.5684 49.7974 51.7327 49.6331 51.9353 49.6331Z",
    fill: "#101828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5342 76.5049H35.5976",
    stroke: "#6565EC",
    strokeWidth: 1.46789
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0386 72.9424L39.1641 80.0679",
    stroke: "#6565EC",
    strokeWidth: 1.46789
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0386 80.0671L39.1641 72.9417",
    stroke: "#6565EC",
    strokeWidth: 1.46789
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.9702,
    y: 75.0041,
    width: 23.176,
    height: 2.9211,
    fill: "#D6DAE4",
    stroke: "#D6DAE4",
    strokeWidth: 0.601489
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5342 90.676H35.5976",
    stroke: "#D6DAE4",
    strokeWidth: 1.46789
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0386 87.1133L39.1641 94.2388",
    stroke: "#D6DAE4",
    strokeWidth: 1.46789
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0386 94.2388L39.1641 87.1133",
    stroke: "#D6DAE4",
    strokeWidth: 1.46789
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.9702,
    y: 89.094,
    width: 27.5792,
    height: 2.9211,
    fill: "#D6DAE4",
    stroke: "#D6DAE4",
    strokeWidth: 0.601489
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5342 119.018H35.5976",
    stroke: "#D6DAE4",
    strokeWidth: 1.46789
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0386 115.455L39.1641 122.581",
    stroke: "#D6DAE4",
    strokeWidth: 1.46789
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0386 122.581L39.1641 115.455",
    stroke: "#D6DAE4",
    strokeWidth: 1.46789
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.9702,
    y: 117.276,
    width: 27.5792,
    height: 2.9211,
    fill: "#D6DAE4",
    stroke: "#D6DAE4",
    strokeWidth: 0.601489
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5342 104.847H35.5976",
    stroke: "#D6DAE4",
    strokeWidth: 1.46789
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0386 101.284L39.1641 108.41",
    stroke: "#D6DAE4",
    strokeWidth: 1.46789
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0386 108.41L39.1641 101.284",
    stroke: "#D6DAE4",
    strokeWidth: 1.46789
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.9702,
    y: 103.185,
    width: 17.8921,
    height: 2.9211,
    fill: "#D6DAE4",
    stroke: "#D6DAE4",
    strokeWidth: 0.601489
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_933_49183",
    x: 5.61269,
    y: 51.9052,
    width: 91.7746,
    height: 102.764,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.693657
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.693657
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.764706 0 0 0 0 0.780392 0 0 0 0 0.815686 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_933_49183"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_933_49183",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_933_49183",
    x: 12.3378,
    y: 51.1125,
    width: 75.8684,
    height: 93.4812,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.693657
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.693657
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.764706 0 0 0 0 0.780392 0 0 0 0 0.815686 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_933_49183"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_933_49183",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_933_49183",
    x: 43.9784,
    y: 44.9267,
    width: 13.0276,
    height: 12.2934,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.733945
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.733945
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.027451 0 0 0 0 0.12549 0 0 0 0 0.239216 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_933_49183"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_933_49183",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestopsStep9);
export default __webpack_public_path__ + "static/media/testops_step9.7320c16c206b75fc28ab78f452236421.svg";
export { ForwardRef as ReactComponent };